module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.showModalEnviarRegulacao) ? _c('modal-enviar-regulacao', {
    on: {
      "close": function($event) {
        _vm.showModalEnviarRegulacao = false
      },
      "enviaRegulacao": function (motivo) { return _vm.enviaRegulacao(motivo); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "20px",
      "z-index": "9999999"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")]), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar ")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_unidade), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getProfissionaisAndDiasByUnidade(index, item[0].unidade_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexUnidadeAtiva === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item[0].unidade.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_vm._v("Atendimentos Disponíveis:\n                           "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasPrimeira(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasRetorno(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasLocal(item)))]) : _vm._e()])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima"
  }, _vm._l((_vm.vagas_profissional), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getDiasByUnidadeAndProfissional(index, item[0].profissional_id)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexProfissionalAtivo === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item[0].profissional.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_vm._v("Atendimentos Disponíveis:\n                           "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasPrimeira(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasRetorno(item)))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(_vm.getQtdVagasLocal(item)))]) : _vm._e()])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "260px"
    }
  }, [(_vm.optionsCalendario.enabledDates) ? _c('date-picker', {
    attrs: {
      "config": _vm.optionsCalendario
    },
    on: {
      "dp-change": _vm.getProfissionaisByUnidadeAndDia
    },
    model: {
      value: (_vm.selecionados.data),
      callback: function($$v) {
        _vm.$set(_vm.selecionados, "data", $$v)
      },
      expression: "selecionados.data"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "divListVagas"
  }, [_c('div', {
    staticClass: "panel panel-default panel-table listbox"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "listsVagas tamanho-fixo-agenda-cima listbox"
  }, _vm._l((_vm.vagas_filtradas), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selecionaVaga(index)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item list-group-item-action list-group-item-warning",
      class: {
        'ativa': _vm.selecionados.indexVagaAtiva === index
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("uppercase")(item.unidade.nome)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Data:")]), _vm._v("\n                            " + _vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " à partir das\n                            "), _c('b', [_vm._v(_vm._s(_vm._f("horaFormatada")(item.hora_inicial)))]), _vm._v(" horas.\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Profissional:")]), _vm._v("\n                            " + _vm._s(item.profissional.nome) + "\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador'),
        expression: "$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
      }]
    }, [_c('strong', [_vm._v("Atendimentos Disponíveis:")]), _vm._v(" "), (_vm.$props.tipoVaga == 0) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_primeira))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 1) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_retorno))]) : _vm._e(), _vm._v(" "), (_vm.$props.tipoVaga == 2) ? _c('strong', [_vm._v(" " + _vm._s(item.quantidade_local))]) : _vm._e()]), _vm._v(" "), ((_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador') && (_vm.idadePacienteSelecionado < item.idade_minima || _vm.idadePacienteSelecionado > item.idade_maxima)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('span', [_c('strong', [_vm._v("Idade Mínima:")]), _vm._v("\n                                " + _vm._s(item.idade_minima) + "\n                              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Idade Máxima:")]), _vm._v("\n                                " + _vm._s(item.idade_maxima) + "\n                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "alert alert-warning alert-dismissible"
    }, [_vm._m(5, true), _vm._v("\n                                A idade do paciente (" + _vm._s(_vm.idadePacienteSelecionado) + ") não obedece os limites do atendimento.\n                              ")])])]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.$store.state.user.nivel == 'regulador' || _vm.$store.state.user.nivel == 'administrador') && (item.cotaSolicitante == false || item.cotaPrestador == false || item.vagaPrestador == false)),
        expression: "($store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador') && (item.cotaSolicitante == false || item.cotaPrestador == false || item.vagaPrestador == false)"
      }],
      staticStyle: {
        "color": "red"
      }
    }, [_c('strong', [_vm._v("ATENÇÃO (EXTRAPOLAÇÃO): O atendimento selecionado possui as seguintes restrições: ")]), _vm._v(" "), _c('ul', [(item.cotaSolicitante == false) ? _c('li', [_c('strong', [_vm._v("Não há limite (cota) para a unidade solicitante!")])]) : _vm._e(), _vm._v(" "), (item.cotaPrestador == false) ? _c('li', [_c('strong', [_vm._v("Não há limite (cota) para a unidade prestadora!")])]) : _vm._e(), _vm._v(" "), (item.vagaPrestador == false) ? _c('li', [_c('strong', {
      staticStyle: {
        "font-size": "30px",
        "text-decoration": "blink"
      }
    }, [_vm._v("Não há atendimento (vaga) disponível!")])]) : _vm._e()])])])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "20px",
      "z-index": "9999999"
    }
  }, [(!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Confirmar\n\t\t\t  ")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.informacaoPendente
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Solicitar informação pendente")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.negativar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Negativar")]) : _vm._e(), _vm._v(" "), (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.confirma
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Regular\n\t\t\t  ")]) : _vm._e(), _vm._v(" "), (!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.showModalEnviarRegulacao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Regulação\n\t\t\t  ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar\n      ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Selecione o atendimento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione uma unidade")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Selecione um profissional")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('b', [_vm._v("Selecione uma data")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-12"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_vm._v("Atendimentos")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" Atenção!\n                                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2e3f5cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/resolucaoIndividual.vue
// module id = 823
// module chunks = 0